import { ChartingFailureRelatedIDs, failureReasonFormatted, FailureReason, ChartingItemType, ChartingRequiredCondition } from '@caresend/types';
import { isNullish } from '@caresend/utils';
import { setProcedureChartingItems } from '../components/specific/portal/store/portal/set/procedure.js';
import '@sentry/vue';
import { toastError } from './toast/toast.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../components/ui/Icon.vue.js';
import './configuration/icons.js';
import '../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import './tracking/index.js';
import '../components/specific/portal/store/portal/sessionStore.js';
import 'vue';
import 'file-saver';
import '../database/firebaseConfig/cloudFunctions.js';
import '../database/encryption/model.js';
import 'js-sha256';
import { getStore } from '../store/helpers/initStore.js';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../components/specific/portal/store/storeUtilities/dbSync/dbSyncStore.js';
import '../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../database/firebaseConfig/init.js';
import '../database/firebaseConfig/methods.js';
import '../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'immutability-helper';
import '../router/routes/dev/model.js';
import '../router/routes/dev/routes.js';
import '../router/routes/dashboard/model.js';
import '../router/routes/pro/model.js';
import '../router/routes/visitsPage/model.js';
import '../router/routes/orderFlow/model.js';
import '../router/routes/orderFlow/privateHelpers.js';
import '../router/routes/orderFlow/routes.js';
import '../router/routes/schedulingFlow/model.js';
import '../router/routes/schedulingFlow/routes.js';
import '../router/routes/chartingFlow/model.js';
import '../router/routes/chartingFlow/routes.js';
import '../router/routes/portal/portalRoutes.js';
import '../router/routes/portal/model.js';
import '../router/routes/visitsPage/routes.js';
import '../components/specific/dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../store/modules/auth/index.js';
import 'dayjs';
import '../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../store/modules/chartingFlow/model.js';
import '../store/modules/office/index.js';
import '../components/specific/VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../store/modules/office/model.js';
import '../store/modules/orderFlow/index.js';
import '../store/modules/procedures/model.js';
import '../store/modules/schedulingFlow/index.js';
import '../store/modules/schedulingFlow/model.js';

const hasNotes = (params, id) => {
    var _a;
    const { chartingItems } = params;
    const notes = (_a = chartingItems.find((chartingItem) => {
        var _a;
        const notesID = (_a = chartingItem.productID) !== null && _a !== void 0 ? _a : chartingItem.taskID;
        return chartingItem.type === ChartingItemType.NOTES
            && notesID === id;
    })) === null || _a === void 0 ? void 0 : _a.text;
    return !!notes;
};
const checkItem = (params, item, itemFilled, productOrTaskID, index, isFollowUpAndNotShown, checklistItemIndex) => {
    const { procedureID, groupIndex } = params;
    switch (item.requiredCondition) {
        case ChartingRequiredCondition.TRUE: {
            if (isFollowUpAndNotShown)
                return true;
            let newPartialChartingItem = {};
            const chartingItemIndexArray = groupIndex ? groupIndex.concat(index) : index;
            const setChartingItemParams = {
                procedureID,
                chartingItemIndexArray,
                checklistItemIndex,
            };
            if (!itemFilled && !item.highlight) {
                newPartialChartingItem.highlight = true;
                if (checklistItemIndex) {
                    setChartingItemParams.newChartingChecklistItem = newPartialChartingItem;
                }
                else {
                    setChartingItemParams.newPartialChartingItem = newPartialChartingItem;
                }
                setProcedureChartingItems(setChartingItemParams);
            }
            if (itemFilled && item.highlight) {
                newPartialChartingItem = {
                    highlight: false,
                };
                if (checklistItemIndex) {
                    setChartingItemParams.newChartingChecklistItem = newPartialChartingItem;
                }
                else {
                    setChartingItemParams.newPartialChartingItem = newPartialChartingItem;
                }
                setProcedureChartingItems(setChartingItemParams);
            }
            return itemFilled;
        }
        case ChartingRequiredCondition.FALSE:
        case undefined: {
            return true;
        }
        case ChartingRequiredCondition.CHART_IF_TRUE: {
            return !itemFilled || (itemFilled && hasNotes(params, productOrTaskID));
        }
        case ChartingRequiredCondition.CHART_IF_FALSE: {
            return itemFilled || (!itemFilled && hasNotes(params, productOrTaskID));
        }
    }
};
const filesMeetsRequiredConditions = (params, chartingItem, id, index, isFollowUpAndNotShown) => {
    var _a;
    return checkItem(params, chartingItem, !!((_a = chartingItem.files) === null || _a === void 0 ? void 0 : _a.length), id, index, isFollowUpAndNotShown);
};
const checklistItemsMeetRequiredConditions = (params, checklist, id, index, isFollowUpAndNotShown) => {
    if (!checklist || !id)
        return false;
    const failedItems = checklist.filter((checkbox, checkboxIndex) => !checkItem(params, checkbox, !!checkbox.checked, id, index, isFollowUpAndNotShown, checkboxIndex));
    const someChecklistItemFailed = failedItems.length > 0;
    return !someChecklistItemFailed;
};
const textItemMeetsRequiredCondition = (params, item, id, index, isFollowUpAndNotShown) => checkItem(params, item, !!item.text, id, index, isFollowUpAndNotShown);
const selectItemMeetsRequiredCondition = (params, item, id, index, isFollowUpAndNotShown) => checkItem(params, item, !!item.selection, id, index, isFollowUpAndNotShown);
const dateMeetsRequiredCondition = (params, item, id, index, isFollowUpAndNotShown) => checkItem(params, item, !!item.date, id, index, isFollowUpAndNotShown);
/**
* Collection of all charting items that have been specified as conditional follow-ups by a sibling
* and whether they should be displayed on screen.
*
* Maps from {@link ChartingItem.id} to a boolean indicating whether the item should be shown.
*
* This is determined by evaluating the conditions in the sibling's conditionalFollowUps array.
*/
const getConditionalFollowUpDisplayMap = (chartingItems) => chartingItems.reduce((acc, item) => {
    var _a;
    (_a = item.conditionalFollowUps) === null || _a === void 0 ? void 0 : _a.forEach((followUp) => {
        acc[followUp.followUpID] = !isNullish(followUp.showOnValues)
            ? followUp.showOnValues.includes(item[followUp.valueName])
            : isNullish(item[followUp.valueName]);
    });
    return acc;
}, {});
const chartingComplete = (params) => {
    const { chartingItems } = params;
    // If charting item id is in the map, then the item should be shown conditionally
    const conditionalFollowUpDisplayMap = getConditionalFollowUpDisplayMap(chartingItems);
    const itemMeetsRequiredConditions = (chartingItem, isFollowUpAndNotShown, index) => {
        var _a;
        const { procedureID } = params;
        const id = (_a = chartingItem.productID) !== null && _a !== void 0 ? _a : chartingItem.taskID;
        if (!id || !chartingItem.type)
            return false;
        switch (chartingItem.type) {
            case ChartingItemType.CHECKLIST: {
                return checklistItemsMeetRequiredConditions(params, chartingItem.checklist, id, index, isFollowUpAndNotShown);
            }
            case ChartingItemType.DATE:
                return dateMeetsRequiredCondition(params, chartingItem, id, index, isFollowUpAndNotShown);
            case ChartingItemType.FILES:
                return filesMeetsRequiredConditions(params, chartingItem, id, index, isFollowUpAndNotShown);
            case ChartingItemType.GROUP: {
                if (!chartingItem.children) {
                    toastError('There was an error with the charting items.');
                    return true;
                }
                const chartingChildrenParams = {
                    chartingItems: chartingItem.children,
                    procedureID,
                    groupIndex: index,
                };
                // on groups, if followup item is not shown, we don't need to check the children
                return isFollowUpAndNotShown || chartingComplete(chartingChildrenParams);
            }
            case ChartingItemType.NOTES:
            case ChartingItemType.TEXT:
                return textItemMeetsRequiredCondition(params, chartingItem, id, index, isFollowUpAndNotShown);
            case ChartingItemType.RESULTS:
            case ChartingItemType.SELECT:
                return selectItemMeetsRequiredCondition(params, chartingItem, id, index, isFollowUpAndNotShown);
        }
    };
    const failedItems = chartingItems.filter((item, index) => !itemMeetsRequiredConditions(item, !!item.id && conditionalFollowUpDisplayMap[item.id] === false, [index]));
    const someItemFailedRequiredConditions = failedItems.length > 0;
    return !someItemFailedRequiredConditions;
};
/**
 * Builds a {@link ProcedureFailed} object from the procedure's failure-related charting items.
 *
 * @param failureChartingItems - The usually the {@link ChartingItem.children} of the charting item with id
 * {@link ChartingFailureRelatedIDs.CHARTING_FAILURE_REASON}.
 * @returns A ProcedureFailed object or undefined if there was an error.
 */
// TOOD: Possibly return an `EncryptedProcedureFailed` object.
const buildProcedureFailedFromCharting = (failureChartingItems) => {
    var _a, _b, _c, _d;
    const [failureReasonItem, failureSpecifySupplyItem, failureSpecifyVenipunctureItem,] = failureChartingItems;
    if (!failureReasonItem || !failureSpecifySupplyItem || !failureSpecifyVenipunctureItem) {
        toastError('There was an error with the charting items.');
        return;
    }
    if (failureReasonItem.id !== ChartingFailureRelatedIDs.CHARTING_FAILURE_REASON_VERSION
        || failureSpecifySupplyItem.id !== ChartingFailureRelatedIDs.CHARTING_FAILURE_REASON_SPECIFY_SUPPLY
        || failureSpecifyVenipunctureItem.id !== ChartingFailureRelatedIDs.CHARTING_FAILURE_REASON_SPECIFY_VENIPUNCTURE) {
        toastError('There was an error with the charting items.');
        return;
    }
    const failureReason = (_a = Object.entries(failureReasonFormatted)
        .find(([_, r]) => r === failureReasonItem.selection)) === null || _a === void 0 ? void 0 : _a[0];
    if (!failureReason) {
        toastError('There was an error with the charting items.');
        return;
    }
    const detailedReason = failureReason === FailureReason.SUPPLY_ISSUE
        ? failureSpecifySupplyItem.selection
        : failureSpecifyVenipunctureItem.selection;
    if (!detailedReason) {
        toastError('There was an error with the charting items.');
        return;
    }
    return {
        failedBy: (_c = (_b = getStore().state.auth.user) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : '',
        failedByRole: (_d = getStore().state.auth.user) === null || _d === void 0 ? void 0 : _d.role,
        timestamp: Date.now(),
        reason: failureReason,
        detailedReason,
    };
};

export { buildProcedureFailedFromCharting, chartingComplete, getConditionalFollowUpDisplayMap };
